import React from 'react';
import { connect } from 'react-redux';
import { accountOperations } from 'insured-ui-state-mgmt/dist/ducks/account';
import PropTypes from 'prop-types';
import Loading from '../registrationScreens/Loading';

// import NotificationSystem from 'react-notification-system';
// import { AddNotification, NotificStyle } from '../assets/constants/notification';
import { AddPolicyPage } from '../assets/constants/constants';
import { Modal, Button, Alert } from 'react-bootstrap';

class AccountAccessScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      message: '',
      show: true,
    };
    //TODO: added for demo - quick fix
    // $('#showSignupModal').click();
    this.notificationSystem = React.createRef();
  }

  componentDidMount() {
    const { userIdToken, dateTimeToken, emailToken } = this.props.$stateParams;
    this.props.verifyAccount(userIdToken, dateTimeToken, emailToken);
  }

  componentDidUpdate(prevProps) {
    if (!Object.is(this.props.response, prevProps.response)) {
      if (this.props.response.code === 0) {
        let msg = '';
        if (this.props.response.message) {
          msg = this.props.response.message;
        } else {
          msg = 'Your account has been verified successfully.';
        }
        this.setState({ loading: false, message: msg });
        this.props.setAccountInfo({ email: this.props.response.email });
        return;
      }

      // if (this.props.response.message) {
      //   this._addNotification('error', 'Api Error', this.props.response.message);
      // } else {
      //   this._addNotification('error', 'Api Error', 'ErrorCode: ' + this.props.response.code);
      // }
      // this.setState({
      //   loading: false,
      //   message: this.props.response.message,
      // });
    }
  }

  _continue() {
    if (this.props.account.email && this.props.account.email !== '') {
      window.location.href = AddPolicyPage;
      // this.props.transition.router.stateService.go('registrationScreen3', {}, { location: true });
    }
  }

  // _addNotification = (notificLevel, messageTitle, messageBody) => {
  //   AddNotification(this.notificationSystem.current, notificLevel, messageTitle, messageBody);
  // };

  handleClose = () => {
    this.setState({
      show: false,
    });
  };

  render() {
    const { isLoading, show } = this.state;
    const { loading } = this.props;

    return (
      <Modal
        show={show}
        onHide={this.handleClose}
        backdrop="static"
        dialogClassName="modal-md modal_400 relative_position"
      >
        <Modal.Header closeButton={!Boolean(loading)}>
          <Modal.Title>Create Account</Modal.Title>
        </Modal.Header>

        {Boolean(loading) && <Loading show={Boolean(loading)} />}

        {!Boolean(loading) &&
          this.props.response &&
          this.props.response.code === 0 && (
            <Modal.Body style={{ margin: 20 }} bsClass="modal-body modal_body_450">
              <p>
                You’ve successfully created your West Bend Mutual Insurance online account and it is now established!
                Please be sure to keep your password safe and secure.
              </p>

              <Button
                bsStyle="primary"
                bsSize="large"
                block
                disabled={Boolean(loading)}
                onClick={() => this._continue()}
                style={{ marginTop: 20 }}
              >
                Access Account
              </Button>
            </Modal.Body>
          )}

        {this.props.response &&
          this.props.response.code > 0 &&
          this.props.response.message && (
            <Modal.Footer>
              <Alert bsStyle="danger">
                <strong>Api Error</strong> {this.props.response.message}
              </Alert>
            </Modal.Footer>
          )}

        {/* <div>
            <NotificationSystem ref={this.notificationSystem} style={NotificStyle} />
          </div> */}
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  //routeParams: ownProps.resolves.$stateParams,
  account: state.account.registrationDetails,
  response: state.account.response,
  extra: state.extra,
  loading: state.loading,
});
const mapDispatchToProps = {
  setAccountInfo: accountOperations.registerUser_1,
  verifyAccount: accountOperations.verifyUser,
};
AccountAccessScreen.propTypes = {
  $stateParams: PropTypes.object,
  account: PropTypes.object,
  response: PropTypes.object,
  routeParams: PropTypes.object,
  setAccountInfo: PropTypes.func,
  transition: PropTypes.object,
  verifyAccount: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountAccessScreen);
